import React, { Component } from "react";

import Constants from "../../../utils/constants";

import dayjs from "dayjs";

const styles = {
  document: {
    color: "#000000",
    fontFamily: "sans-serif",
    fontSize: "9pt",
  },
  logo: {
    marginBottom: "10pt",
    textAlign: "center",
  },
  companyAddress: {
    marginBottom: "10pt",
  },
  addressTable: {
    border: "none",
    borderCollapse: "collapse",
    marginBottom: "16pt",
    width: "100%",
  },
  addressCell: {
    border: "none",
    padding: "2pt 4pt",
    verticalAlign: "top",
  },
  documentTitle: {
    fontSize: "16pt",
    margin: "0 0 16pt",
    textAlign: "center",
  },
  sectionTable: {
    borderCollapse: "collapse",
    marginBottom: "16pt",
    width: "100%",
  },
  sectionHeader: {
    backgroundColor: "#afaeae",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "left",
  },
  sectionCell: {
    backgroundColor: "#eeeeee",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    verticalAlign: "top",
  },
  linesTable: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    marginBottom: "16pt",
    width: "100%",
  },
  columnHeader: {
    backgroundColor: "#f4c181",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "left",
    verticalAlign: "middle",
  },
  amountHeader: {
    backgroundColor: "#f4c181",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "right",
    verticalAlign: "middle",
  },
  cell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    verticalAlign: "top",
  },
  amountCell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  totalLabelCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
  },
  totalAmountCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  separator: {
    borderTop: "1px solid #D3D3D3",
    margin: "16pt 0",
  },
};

export default class AvisEcheancePDF extends Component {
  addSpaces(numSpaces, str) {
    return " ".repeat(numSpaces) + str;
  }

  render() {
    const { avis, utilisateur } = this.props;

    const societe = utilisateur.utilisateur_societe;

    const chemin = `${Constants.mode}://${Constants.domain}:${Constants.port}/api/societe/display/${societe.societe_id}`;

    let width = 200;
    let height = 30;

    if (societe.societe_logo_width) width = societe.societe_logo_width;
    if (societe.societe_logo_height) height = societe.societe_logo_height;

    const locataire = avis.locataire;
    const lot = avis.lot;

    const totalAvis = avis.location_ligne.reduce(
      (a, b) => a + parseFloat(b.location_ligne_montant),
      0
    );

    const resteDu = parseFloat(totalAvis + avis.solde);

    return (
      <div style={styles.document}>
        {/* LOGO SOCIETE */}
        <div style={styles.logo}>
          <img src={chemin} width={width} height={height} alt="" />
        </div>

        {/* ADRESSE SOCIETE */}
        <div style={styles.companyAddress}>
          <strong>{`${societe.societe_raison_sociale}`}</strong>
          <br />
          {`${societe.societe_adresse.adresse_numero} ${societe.societe_adresse.adresse_voie}`}
          <br />
          {`${societe.societe_adresse.adresse_code_postal} ${societe.societe_adresse.adresse_ville}`}
        </div>

        {/* ADRESSE LOCATAIRE */}
        <div>
          <table style={styles.addressTable}>
            <tbody>
              <tr>
                <td width="55%" style={styles.addressCell}></td>
                <td width="45%" style={styles.addressCell}>
                  <strong>
                    {`${locataire.locataire_personne.personne_qualite.qualite_libelle} ${locataire.locataire_personne.personne_nom} ${locataire.locataire_personne.personne_prenom ?? ""}`}
                  </strong>
                  <br />
                  {`${locataire?.locataire_personne?.personne_adresse?.adresse_numero ?? ""} ${locataire?.locataire_personne?.personne_adresse?.adresse_voie ?? ""}`}
                  <br />
                  {`${locataire?.locataire_personne?.personne_adresse?.adresse_code_postal ?? ""} ${locataire?.locataire_personne?.personne_adresse?.adresse_ville ?? ""}`}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* TITRE DOCUMENT */}
        <div style={styles.documentTitle}>
          <strong>
            {`AVIS D'ÉCHÉANCE`}
            <br />
            {`PÉRIODE DU ${dayjs(avis.date_debut).format("DD/MM/YYYY")} AU ${dayjs(
              avis.date_fin
            ).format("DD/MM/YYYY")}`}
          </strong>
        </div>

        {/* LOCATION */}
        <table style={styles.sectionTable}>
          <thead>
            <tr>
              <th style={styles.sectionHeader}>
                <strong>Location</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={styles.sectionCell}>
                {`Référence: ${lot.lot_reference}`}
                <br />
                {`Adresse:`}
                <br />
                {`${lot.lot_adresse.adresse_numero} ${lot.lot_adresse.adresse_voie}`}
                <br />
                {`${lot.lot_adresse.adresse_code_postal} ${lot.lot_adresse.adresse_ville}`}
              </td>
            </tr>
          </tbody>
        </table>

        {/* LIGNES QUITTANCES */}
        <table style={styles.linesTable}>
          <thead>
            <tr>
              <th width="50%" style={styles.columnHeader}>
                <strong>Libellé</strong>
              </th>
              <th width="25%" style={styles.columnHeader}></th>
              <th width="25%" style={styles.amountHeader}>
                <strong>{`Montant`}</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            {avis.location_ligne
              .sort(
                (a, b) =>
                  a.location_ligne_rubrique.rubrique_id - b.location_ligne_rubrique.rubrique_id
              )
              .map((ligne, i) => {
                //console.log(ligne);
                return (
                  <tr
                    key={i}
                    style={{ backgroundColor: i % 2 === 0 ? "#ffffff" : "#eeeeee" }}
                  >
                    <td width="50%" style={styles.cell}>
                      {ligne.location_ligne_libelle || ligne.location_ligne_rubrique.rubrique_libelle}
                    </td>
                    <td width="25%" style={styles.cell}></td>
                    <td width="25%" style={styles.amountCell}>
                      {parseFloat(ligne.location_ligne_montant).toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                  </tr>
                );
              })}
          </tbody>
          <tfoot>
            <tr>
              <th width="50%" style={styles.totalLabelCell}></th>
              <th width="25%" style={styles.totalLabelCell}>
                <strong>{`TOTAL DU TERME:`}</strong>
              </th>
              <td width="25%" style={styles.totalAmountCell}>
                <strong>
                  {parseFloat(totalAvis).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </strong>
              </td>
            </tr>
            <tr>
              <th width="50%" style={styles.totalLabelCell}></th>
              <th width="25%" style={styles.totalLabelCell}>
                <strong>ARRIÉRÉS:</strong>
              </th>
              <td width="25%" style={styles.totalAmountCell}>
                <strong>
                  {parseFloat(avis.solde).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </strong>
              </td>
            </tr>
            <tr>
              <th width="50%" style={styles.totalLabelCell}></th>
              <th width="25%" style={styles.totalLabelCell}>
                <strong>TOTAL À REGLER:</strong>
              </th>
              <td width="25%" style={styles.totalAmountCell}>
                <strong>
                  {parseFloat(resteDu).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </strong>
              </td>
            </tr>
          </tfoot>
        </table>

        <br />
        <br />

        {avis.quittance && avis.quittance.solde === 0 && (
          <>
            <div style={styles.separator}></div>

            {/* TITRE DOCUMENT */}
            <div style={styles.documentTitle}>
              <strong>
                {`QUITTANCE`}
                <br />
                {`PÉRIODE DU ${dayjs(avis.quittance.quittance_date_debut).format(
                  "DD/MM/YYYY"
                )} AU ${dayjs(avis.quittance.quittance_date_fin).format("DD/MM/YYYY")}`}
              </strong>
            </div>

            {/* LIGNES QUITTANCES */}
            <table style={styles.linesTable}>
              <thead>
                <tr>
                  <th width="50%" style={styles.columnHeader}>
                    <strong>Libellé</strong>
                  </th>
                  <th width="25%" style={styles.columnHeader}></th>
                  <th width="25%" style={styles.amountHeader}>
                    <strong>{`Montant`}</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {avis.quittance.quittance_ligne
                  .sort(
                    (a, b) =>
                      a.quittance_ligne_rubrique.rubrique_id -
                      b.quittance_ligne_rubrique.rubrique_id
                  )
                  .map((ligne, i) => {
                    //console.log(ligne);
                    return (
                      <tr
                        key={i}
                        style={{ backgroundColor: i % 2 === 0 ? "#ffffff" : "#eeeeee" }}
                      >
                        <td width="50%" style={styles.cell}>
                          {ligne.quittance_ligne_libelle || ligne.quittance_ligne_rubrique.rubrique_libelle}
                        </td>
                        <td width="25%" style={styles.cell}></td>
                        <td width="25%" style={styles.amountCell}>
                          {parseFloat(ligne.quittance_ligne_montant).toLocaleString("fr-FR", {
                            style: "currency",
                            currency: "EUR",
                          })}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
              <tfoot>
                <tr>
                  <th width="50%" style={styles.totalLabelCell}></th>
                  <th width="25%" style={styles.totalLabelCell}>
                    <strong>{`TOTAL DU TERME:`}</strong>
                  </th>
                  <td width="25%" style={styles.totalAmountCell}>
                    <strong>
                      {parseFloat(
                        avis.quittance.quittance_ligne.reduce(
                          (a, b) => a + parseFloat(b.quittance_ligne_montant),
                          0
                        )
                      ).toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </>
        )}
      </div>
    );
  }
}
